import React, { useState } from 'react';

export default function NotifyPopup({ visible, onClose }) {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  if (!visible) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        {!submitted ? (
          <>
            <h2 style={styles.title}>Get Notified</h2>
            <p style={styles.desc}>Enter your email and we’ll let you know when it’s live.</p>
            <form onSubmit={handleSubmit}>
              <input
                type="email"
                placeholder="Your email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={styles.input}
              />
              <button type="submit" style={styles.submitBtn}>Submit</button>
            </form>
          </>
        ) : (
          <>
            <h2 style={styles.title}>Thank You!</h2>
            <p style={styles.desc}>We’ll notify you as soon as it launches.</p>
          </>
        )}
        <button onClick={onClose} style={styles.closeBtn}>Close</button>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 999,
  },
  modal: {
    background: '#fff',
    padding: '2rem',
    borderRadius: '12px',
    width: '100%',
    maxWidth: '400px',
    textAlign: 'center',
    boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 700,
    marginBottom: '0.5rem',
  },
  desc: {
    fontSize: '1rem',
    marginBottom: '1.5rem',
  },
  input: {
    width: '100%',
    padding: '0.75rem',
    borderRadius: '6px',
    border: '1px solid #ccc',
    marginBottom: '1rem',
    fontSize: '1rem',
  },
  submitBtn: {
    width: '100%',
    background: '#1E3FA6',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    padding: '0.75rem',
    fontWeight: 600,
    fontSize: '1rem',
    cursor: 'pointer',
  },
  closeBtn: {
    marginTop: '1rem',
    background: 'transparent',
    border: 'none',
    color: '#555',
    fontSize: '0.9rem',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
};
